/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SysOrgRoleName {
    GUEST = 'Guest',
    MEMBER = 'Member',
    VIEW_SETUP = 'ViewSetup',
    SETUP_BASIC = 'SetupBasic',
    SETUP_ITEMS = 'SetupItems',
    USER_ADMIN = 'UserAdmin',
    CLIENT_SUPPORT = 'ClientSupport',
    HAVN_SUPPORT = 'HavnSupport',
    _UNKNOWN = '_Unknown',
}
